module.exports = __webpack_public_path__ + "static/media/plus.8c767010.png";